import type React from "react";
import type { SubAgentId } from "@/features/ads";
import { ChatPanelHeader } from "./ChatPanelHeader";
import { ScoutChatView } from "./cards/ScoutChatView";
import { SubAgentChatView } from "./cards/SubAgentChatView";

export type SubAgentHeaderVariant = "default" | "adsCli";

export type SubAgentToolPartRenderer = (
  part: Record<string, unknown>,
  index: number,
) => React.ReactNode;

export interface CompanionSubAgentPanelRenderContext {
  agentId: SubAgentId;
  renderToolPart?: SubAgentToolPartRenderer;
}

interface SubAgentChatPanelProps {
  agentId: SubAgentId;
  headerVariant?: SubAgentHeaderVariant;
  onBackToList?: () => void;
  onCreateSession?: () => void | Promise<void>;
  sessionControlsDisabled?: boolean;
  headerActions?: React.ReactNode;
  afterHeader?: React.ReactNode;
  children?: React.ReactNode;
  renderToolPart?: SubAgentToolPartRenderer;
}

export function SubAgentChatPanel({
  agentId,
  headerVariant,
  onBackToList,
  onCreateSession,
  sessionControlsDisabled,
  headerActions,
  afterHeader,
  children,
  renderToolPart,
}: SubAgentChatPanelProps) {
  return (
    <div className="flex flex-col h-full relative">
      <ChatPanelHeader
        headerVariant={headerVariant}
        isStreaming={false}
        onBackToList={onBackToList}
        onCreateSession={onCreateSession}
        sessionControlsDisabled={sessionControlsDisabled}
        headerActions={headerActions}
      />
      {afterHeader}
      <div className="flex-1 min-h-0">
        {children ??
          (agentId === "scout" ? (
            <ScoutChatView />
          ) : (
            <SubAgentChatView agentId={agentId} hideHeader renderToolPart={renderToolPart} />
          ))}
      </div>
    </div>
  );
}
